import styled from 'styled-components';

export const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.6rem;
  padding: 1.2rem 1.6rem 0.4rem;
`;

export const Button = styled.button<{ $copied?: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 0.8rem;
  padding: 1rem 1.6rem;
  background-color: ${({ $copied, theme }) =>
    $copied ? theme.colors.successBgSoft : theme.colors.surfaceSoft};
  border: 0.1rem solid
    ${({ $copied, theme }) =>
      $copied ? theme.colors.successBorder : theme.colors.border};
  color: ${({ $copied, theme }) =>
    $copied ? theme.colors.successText : theme.colors.darkSlate};
  border-radius: 999rem;
  font-size: 1.3rem;
  font-weight: 600;
  cursor: pointer;
  transition:
    background-color 0.15s ease,
    border-color 0.15s ease,
    color 0.15s ease,
    transform 0.15s ease;

  &:hover {
    background-color: ${({ $copied, theme }) =>
      $copied ? theme.colors.successBgSoft : theme.colors.surface};
    transform: translateY(-0.1rem);
  }

  &:active {
    transform: translateY(0);
  }
`;

export const Hint = styled.span`
  font-size: 1.1rem;
  color: ${({ theme }) => theme.colors.slateGrey};
  text-align: center;
`;
